import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
  standalone: false,
})
export class CookieConsentComponent implements OnInit {
  visible = false;
  showCustomizeModal = false;

  constructor(private location: Location){}

  ngOnInit(): void {
    const consent = localStorage.getItem('cookieConsent');
    const required = localStorage.getItem('cookieConsentRequired');
    if (JSON.parse(required ?? 'true') && !consent){
      this.visible = true;
    }
  }

  acceptAll() {
    localStorage.setItem('cookieConsent', 'accepted');
    this.visible = false;
  }

  rejectAll() {
    this.visible = false;
    this.location.back();
  }

  customize() {
    this.showCustomizeModal = true;
  }

  savePreferences() {
    this.acceptAll();
    this.showCustomizeModal = false;
  }

  closeCustomize() {
    this.showCustomizeModal = false;
  }
}
